import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-remember-me-info-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <h2 mat-dialog-title>
      <mat-icon>info</mat-icon>
      Remember Me
    </h2>
    <mat-dialog-content>
      <p>Your phone number will be securely encrypted and stored on this device for 30 days. You will still need to enter your date of birth each time you log in.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button mat-dialog-close color="primary">OK</button>
    </mat-dialog-actions>
  `,
  styles: [`
    h2 {
      display: flex;
      align-items: center;
      gap: 12px;
      margin: 0;
      padding: 24px 24px 16px;
      font-size: 20px;
      font-weight: 500;

      mat-icon {
        color: var(--primary-color);
        font-size: 24px;
        width: 24px;
        height: 24px;
      }
    }

    mat-dialog-content {
      padding: 0 24px 24px;

      p {
        margin: 0;
        font-size: 14px;
        line-height: 1.5;
        color: rgba(0, 0, 0, 0.6);
      }
    }

    mat-dialog-actions {
      padding: 8px 16px 16px;
      margin: 0;

      button {
        min-width: 80px;
      }
    }
  `]
})
export class RememberMeInfoDialogComponent {}
